const tabsNoUnderlineSx = {
  '& .MuiTab-root': {
    textDecoration: 'none'
  },
  '& .MuiTab-root:hover': {
    textDecoration: 'none'
  },
  '& .MuiTab-root.Mui-selected': {
    textDecoration: 'none'
  }
};

const tabNoUnderlineSx = { textDecoration: 'none' };

export { tabsNoUnderlineSx, tabNoUnderlineSx };
